import { type LeadAttachment } from "../../types/lead.types.ts"

interface LeadFolderSummary {
  id: string
  name: string
  count: number
}

/** One row per distinct folder among the lead's files, in first-seen order —
 * the root view's folder list is built from this, never from a separate
 * folders endpoint (the lead payload carries no such thing). */
const summarizeLeadFolders = (files: LeadAttachment[]): LeadFolderSummary[] => {
  const byId = new Map<string, LeadFolderSummary>()

  for (const file of files) {
    if (!file.folder_id || !file.folder_name) continue
    const existing = byId.get(file.folder_id)
    if (existing) existing.count += 1
    else byId.set(file.folder_id, { id: file.folder_id, name: file.folder_name, count: 1 })
  }

  return [...byId.values()]
}

/** `folderId: null` means the root view — files with no folder at all. */
const leadFilesInFolder = (
  files: LeadAttachment[],
  folderId: string | null
): LeadAttachment[] =>
  files.filter((file) => (folderId ? file.folder_id === folderId : !file.folder_id))

export { type LeadFolderSummary, leadFilesInFolder, summarizeLeadFolders }
